import React from 'react'

import LuxuryEscapesSmallLogo from 'components/App/Header/Logo/logos/LuxuryEscapesSmallLogo'
import Caption from 'LuxKit/Typography/Caption'
import Group from 'components/utils/Group'

function LEBookingTag() {
  return (
    <Group
      gap={8}
      tabletGap={4}
      direction="horizontal"
      horizontalAlign="start"
      verticalAlign="center"
    >
      <LuxuryEscapesSmallLogo width={16} />
      <Caption variant="large" weight="bold">
        Luxury Escapes Booking
      </Caption>
    </Group>
  )
}

export default React.memo(LEBookingTag)
